import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  MfaDisableInput,
  MfaEnrollConfirmInput,
  MfaEnrollConfirmResponse,
  MfaEnrollStartResponse,
  MfaStatusResponse,
} from '@orion/contracts';
import { api } from '../../lib/api-client.js';

const MFA_STATUS_KEY = ['mfa-status'];

export function useMfaStatus() {
  return useQuery({ queryKey: MFA_STATUS_KEY, queryFn: () => api.get<MfaStatusResponse>('/auth/mfa/status') });
}

export function useMfaEnrollStart() {
  return useMutation({ mutationFn: () => api.post<MfaEnrollStartResponse>('/auth/mfa/enroll/start') });
}

export function useMfaEnrollConfirm() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: MfaEnrollConfirmInput) => api.post<MfaEnrollConfirmResponse>('/auth/mfa/enroll/confirm', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: MFA_STATUS_KEY }),
  });
}

export function useMfaDisable() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: MfaDisableInput) => api.post<void>('/auth/mfa/disable', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: MFA_STATUS_KEY }),
  });
}
